import { Base } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 * @typedef {NewsletterForm & {
 *   $el: HTMLFormElement,
 * }} NewsletterFormInterface
 */
export default class NewsletterForm extends Base {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'NewsletterForm',
    refs: ['checkboxes[]', 'bulkBtn', 'loader', 'notif'],
  };

  /**
   * Handle submit event.
   * @this {NewsletterFormInterface}
   * @param   {SubmitEvent} event
   * @returns {Promise<void>}
   */
  async onSubmit(event) {
    event.preventDefault();
    this.$refs.notif.textContent = '';
    this.$refs.notif.classList.add('opacity-0');
    this.$refs.loader.classList.add('loader--visible');

    try {
      await fetch(this.$el.getAttribute('action'), {
        method: this.$el.getAttribute('method'),
        body: new FormData(this.$el),
      })
        .then((response) => response.json())
        .then((response) => {
          this.$refs.loader.classList.remove('loader--visible');
          this.$refs.notif.textContent = response.data.message;
          this.$refs.notif.classList.remove('opacity-0');
        });
    } catch {
      this.$refs.loader.classList.remove('loader--visible');
      this.$refs.notif.textContent = 'Une erreur est survenue';
      this.$refs.notif.classList.remove('opacity-0');
    }
  }

  /**
   * Change all checkboxes checked
   */
  onBulkBtnClick() {
    if (!this.isChecked) {
      this.check();
    } else {
      this.uncheck();
    }
  }

  /**
   * Check all checkboxes
   */
  check() {
    this.$refs.checkboxes.forEach((checkbox) => {
      checkbox.checked = true;
    });
    this.$refs.bulkBtn.classList.add('bulk-btn--uncheck');
    this.isChecked = true;
  }

  /**
   * Uncheck all checkboxes
   */
  uncheck() {
    this.$refs.checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
    this.$refs.bulkBtn.classList.remove('bulk-btn--uncheck');
    this.isChecked = false;
  }

  /**
   * Verify if all checkboxes are check
   */
  onCheckboxesClick() {
    let numbersCheck = 0;
    const numCheckboxes = this.$refs.checkboxes.length;
    this.$refs.checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        // eslint-disable-next-line no-plusplus
        numbersCheck++;
      }
    });
    if (numbersCheck >= numCheckboxes) {
      this.$refs.bulkBtn.classList.add('bulk-btn--uncheck');
    } else {
      this.$refs.bulkBtn.classList.remove('bulk-btn--uncheck');
    }
  }
}
